export const strategicAxisLabel = {
  PUBLIC_POLICIES: "Incidencias en políticas públicas para la seguridad ciudadana",
  INSTITUTIONAL_IMPROVEMENT: "Fortalecimiento y construcción de capacidades institucionales",
  VIOLENCE_PREVENTION: "Intervención para la prevención de la violencia",
  RULE_OF_LAW: "Estado de derecho y cultura de la legalidad",
  COMPETITIVENESS: "Competitividad",
  INSTITUTIONAL_IMPROVEMENT_SECURITY_AND_JUSTICE: "Fortalecimiento institucional en seguridad y justicia",
  EVALUATE_MEASURE_AND_MONITOR_GOVERNMENT_ACTION_IN_SECURITY_AND_JUSTICE:
    "Evaluar, medir y monitorear la acción de gobierno en seguridad y justicia",
  CITIZEN_CORRESPONSIBILITY_AGAINST_CRIME: "Corresponsabilidad ciudadana frente al delito",
  COMPETITIVENESS_PROMOTION: "Fomento a la competitividad"
}